import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { RedeemCodeDetail } from './RedeemCodeDetail';
import { RedeemCodeList } from './RedeemCodeList';
import { RedeemCodeSend } from './RedeemCodeSend';

export const RedeemCode = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/send`} component={RedeemCodeSend} />;
    <Route path={`${props.match.path}/list`} component={RedeemCodeList} />;
    <Route path={`${props.match.path}/template/:id/codes`} component={RedeemCodeDetail} />;
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/redeemCode/RedeemCode.tsx